// @ts-strict-ignore
/**
 * @fileoverview A wrapper for root-, lazily- mounted React components
 */

import React, { Suspense } from "react";

import { LoadingSpinner } from "@braze/beacon-core";

import type { SHARED_CONSTANTS_BRAZE_TEAMS } from "@lib/shared_constants";
import type { ValueOf } from "@lib/typeHelpers";

import { useLocalizeYup } from "@services/useLocalizeYup";

import ErrorBoundary from "@components/ErrorBoundary";

export interface RootComponentProps {
  /** the key of the feature to be reported on errors caught at the boundary */
  featureId: string;
  /**
   * team to which to report any issues if so configured
   */
  team?: ValueOf<SHARED_CONSTANTS_BRAZE_TEAMS>;
  children: React.ReactNode;
}

export const RootComponent = ({ featureId, team, children }: RootComponentProps) => {
  // localize the yup validation messages
  useLocalizeYup();
  return (
    /** this is the one case where a team assignment doesn't make sense */
    <ErrorBoundary featureId={featureId} team={team} isRoot>
      <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>
    </ErrorBoundary>
  );
};
